const API_KEY = 'AIzaSyDbtT5jLpfV6QwBVNjeLn3ejGf-5DQFulE'
import axios from 'axios'
import * as WebFont from 'webfontloader'

class FontHelper {
    FONT_LIMIT = 10
    fonts = []
    loadedFonts = {}
    fetchingFonts = false

    constructor() {
        this.get()
    }

    async get() {
        const res = await axios.get(
            'https://www.googleapis.com/webfonts/v1/webfonts?key=' +
                API_KEY +
                '&sort=' +
                'popularity'
        )
        this.fonts = this.mapFonts(res.data.items)
        return this.fonts
    }

    mapFonts(fonts) {
        return fonts.slice().map((font) => {
            const { family, files, variants } = font
            return {
                family,
                files,
                styles: variants,
            }
        })
    }

    loadFonts(fonts) {
        return fonts.forEach((font) => {
            if (this.loadedFonts[font.family]) {
                return false
            }
            this.loadFont(font)
        })
    }

    loadFont(font) {
        try {
            WebFont.load({
                google: {
                    families: [font.family + ':' + font.styles],
                },
            })
            this.loadedFonts[font.family] = true
        } catch (e) {
            this.loadedFonts[font.family] = false
        }
    }

    loadFontsBetweenIndexesOf(from, to) {
        const fonts = this.fonts.slice(from, to)
        return this.loadFonts(fonts)
    }
}

export default new FontHelper()
